export default __webpack_public_path__ + "static/media/selectedAssign.095d99fd.svg";